import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Home } from "./pages/Home";
import { Schedule } from "./pages/Schedule";
import { Gallery } from "./pages/Gallery";
import { Accommodation } from "./pages/Accommodation";
import { Travel } from "./pages/Travel";
import { DressCode } from "./pages/DressCode";
import { RSVP } from "./pages/RSVP";
import { Admin } from "./pages/Admin";
import { AdminLogin } from "./pages/AdminLogin";
import { AdminTravel } from "./pages/AdminTravel";
import TravelForm from "./pages/TravelForm";
import { LanguageProvider } from "./contexts/LanguageContext";

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/schedule" element={<Schedule />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/accommodation" element={<Accommodation />} />
            <Route path="/travel" element={<Travel />} />
            <Route path="/dress-code" element={<DressCode />} />
            <Route path="/rsvp" element={<RSVP />} />
            <Route path="/travel-form" element={<TravelForm />} />
            <Route path="/admin-login" element={<AdminLogin />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/admin/travel" element={<AdminTravel />} />
          </Routes>
        </BrowserRouter>
      </LanguageProvider>
    </div>
  );
}

export default App;
